<!-- компонент: вывод всех аттачей сообщения тикета -->
<template>
		<div v-if="data" :class="tableClass">
			<!-- клипса -->
			<div class="clip"></div>

			<!-- сначала выводим массив картинок -->
			<div v-if="Images && Images.length" class="ticket-messahe-images-wrapper">
				<div v-for="(img, idx) in Images"
					class="attach-small-preview cursor-pointer"
					@click="previewImage(img)">
					<img v-if="img['attach_preview'] || img['attach_file']"
						:src="img['src']"
						:title="img['title']"
						:style="img['style'] ? img['style'] : false" />
				</div>
			</div>

			<!-- теперь идут не картинки -->
			<ul v-if="noImages && noImages.length" class="attach-list-no-image">
				<li v-for="(file, i) in noImages">
					<div class="attach-no-image-preview">{{ getExt(file) }}</div>
					<span>{{ file['attach_text'] && String(file['attach_text']).length ? file['attach_text'] + ' - ' : '' | ftc }}</span>
					<a class="attach-download" :href="APIServerUrl + file['attach_file']">{{ file['attach_name'] }}</a>
					<span> ({{ file['attach_size'] }})</span>
				</li>
			</ul>
			
		</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Helper from '@/helper/helper'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'ticketAttachesComponent',
	//=========================================================================
	// неизменяемые свойства компонента
	//=========================================================================
	props: ['attach', 'type'],
	//=========================================================================
	// переменные
	//=========================================================================
	data() {
		return {
			// данные о приаттаченных файлах
			data: false,
			Images: [],
			noImages: []
		}
	},
	//=========================================================================
	// вычислительные свойства
	//=========================================================================
	computed: {
		tableClass() {
			return 'ticket-message-attaches-wrapper attache-in-' + this.type
		}
	},
	//=========================================================================
	// компонент создан
	//=========================================================================
	created() {
		this.initData()
	},
	//=========================================================================
	// методы
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// инициализация
		//---------------------------------------------------------------------
		initData(data) {
			data = data || this.attach
			// проверка переданных данных
			if (!data || !Array.isArray(data) || !data.length) return

			// Обнулим массивы
			this.Images = []
			this.noImages = []

			// бежим по всему массиву аттачей и собираем картинки и НЕкартинки
			data.forEach((item, idx, arr) => {
				// если это картинка
				if ('attach_type' in item &&
					item['attach_type'] &&
					String(item['attach_type']).substr(0, 5) === 'image' &&
					'attach_file' in item && item['attach_file'])
				{
					// расширение для объекта
					let _ext = Object.assign({
						'src': '/static/img/loading32.gif',
						'title': false,
						'style': false,
						'img': null
					}, item)
					// создаем картинку
					_ext['img'] = new Image()
					_ext['img'].onload = () => {
						// получим реальные размеры картинки
						let _w = _ext['img'].naturalWidth
						let _h = _ext['img'].naturalHeight

						// вычислим кофф
						var _k = 1
						if (_w > _h) _k = 56 / _w
						else _k = 56 / _h

						// получим размеры
						_w = parseInt(_k * _w)
						_h = parseInt(_k * _h)

						// запомним размеры
						_ext['style'] = 'width: ' + _w + 'px; height: ' + _h + 'px;'

						// меняем источник
						_ext['src'] = _ext['img'].src
					}
					_ext['img'].src = this.imageUrl(item)
					// добавляем в массив
					this.Images.push(_ext)
				}
				// если это НЕкартинка
				else this.noImages.push(Object.assign({}, item))
			})

			// если есть какие то данные
			this.data = this.Images.length || this.noImages.length
		},
		//---------------------------------------------------------------------
		// формируем URL
		//---------------------------------------------------------------------
		imageUrl(img) {
			let _url = this.APIServerUrl + img['attach_file']
			if ('attach_preview' in img && img['attach_preview'] && img['attach_preview'] != null)
				_url = this.APIServerUrl + img['attach_preview']
			return _url
		},
		//---------------------------------------------------------------------
		// вызов диалога превьюшки
		//---------------------------------------------------------------------
		previewImage(img) {
			this.$emit('preview', { img, list: this.Images })
		},
		//---------------------------------------------------------------------
		// расширение файла
		//---------------------------------------------------------------------
		getExt(file) {
			let _ext = Helper.getFileExt(file['attach_name'])
			_ext = _ext.toUpperCase().substr(0, 4)
			return _ext
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// наблюдатель
	//=========================================================================
	watch: {
		'attach': function(data) {
			this.initData(data)
		}
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.ticket-message-attaches-wrapper {
	position: relative;
	width: 100%;
	padding: 10px;
	padding-bottom: 0;
	border-radius: 4px;
}

.ticket-messahe-images-wrapper {
	position: relative;

	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	align-items: flex-start;
	-webkit-align-items: flex-start;
}

.attache-in-notice {
	border: 1px solid #ccccee;
}

.attache-in-admin {
    border: 1px solid #ddd;
    background-color: white;
}

.attache-in-client {
    border: 1px solid #99ee99;
    background-color: white;
}

.attach-small-preview {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	align-items: center;
	-webkit-align-items: center;

	justify-content: center;

	width: 60px;
	height: 60px;

	background-color: white;
	margin-bottom: 10px;
	margin-right: 10px;

	overflow: hidden;
	box-shadow: 0px 0px 7px 0px rgba(0,0,0,0.2);

	border-radius: 4px;
}

.attach-small-preview > img {
	border-radius: 4px;	
}

.attach-list-no-image {
    margin: 0;
    padding: 0;
}

.attach-list-no-image li {
    padding: 0;
    list-style-type: none;
    margin: 6px 0;
}

.attach-no-image-preview {
    height: 18px;
    width: 27px;
    background-image: url(/static/img/file.svg);
    background-repeat: no-repeat;
    background-size: contain;
    text-align: center;
    color: white;
    font-size: 8px;
    font-weight: 500;
    line-height: 22px;
    float: left;
    margin-right: 8px;
}

.clip {
	width: 9px;
	height: 31px;
	position: absolute;
	top: -5px;
	right: 10px;
	background: url(/static/img/attachments.png) 0 0 no-repeat;
	background-size: cover;
}
</style>



// WEBPACK FOOTER //
// ticketattaches.vue?649bbf7a